export const REGION = 'us-west-2';
export const USER_POOL_ID = 'us-west-2_qgobjLiKc';
export const APP_CLIENT_ID = '34s42g51oodg7loodinr918b0o';
export const IDENTITY_POOL_ID = 'us-west-2:30e6cad3-5b68-41bf-bbd0-5cabb43f2311';
export const COGNITO_DOMAIN = 'ee-portal-auth-gamma.auth.us-west-2.amazoncognito.com';
export const IS_LOCAL_DEV = 'false';
export const STAGE = 'gamma';
export const APPEAL_ENABLED = 'true';